function SearchInput({ value, onChange, placeholder, className }) {
    return (
        <input
            type="search"
            className={className || 'table-search'}
            placeholder={placeholder || 'Поиск...'}
            value={value}
            onChange={(event) => onChange(event.target.value)}
        />
    );
}

export default SearchInput;
